module.exports = DealsGTMHelper = update: (params) ->
  {category2, category3} = params;
  if window.dataLayer?
    dlUpdate =
      event: 'cat-nav'

    window.dataLayer.push(['dl_categories.splice', 1, 2]);
    dlUpdate.dl_category_sub = category2 or ''

    if category2?
      window.dataLayer.push(['dl_categories.push', category2])

    if category3?
      window.dataLayer.push(['dl_categories.push', category3])

    window.dataLayer.push(dlUpdate)
